var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-336 -388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(336 388)",
    fill: "#e1e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.523-3.909V-5.182h7.5v1.273Z",
    transform: "translate(338.478 400.182)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubQuery);
export default __webpack_public_path__ + "static/media/sub-query.6d55dfa55b32286261c7a4ed57b27e96.svg";
export { ForwardRef as ReactComponent };